import { FC, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { BaseHTTPError } from '@fe-core/errors';
import { TSessionChildren } from '@api/io/session.children.io';
import { useError } from '@hooks/useError';
import { SessionChildrenTable } from './SessionChildrenTable';

type ProjectSelectionSessionsProps = {
  data?: TSessionChildren;
  isLoading: boolean;
  error: BaseHTTPError | null;
};

export const ProjectSelectionSessions: FC<ProjectSelectionSessionsProps> = ({
  data,
  isLoading,
  error,
}) => {
  const intl = useIntl();

  const emitError = useError();
  const emitErrorRef = useRef(emitError);
  emitErrorRef.current = emitError;

  useEffect(() => {
    if (error) {
      emitErrorRef.current({ error, errorMapOverride: { type: 'toast' } });
    }
  }, [error]);

  return (
    <div className="lf:l-page lf:2xl:container">
      <h2 className="lf:py-8 lf:text-headline-sm">
        {intl.formatMessage({ id: 'courses.projectSelection.sessions.title' })}
      </h2>
      <SessionChildrenTable items={data?.items ?? []} isLoading={isLoading} />
    </div>
  );
};
